import React from "react";
import { DeltaBattleScreen } from "./DeltaBattleScreen";

export const DeltaPlayer5GameScreen = (props) => (
    <DeltaBattleScreen
        {...props}
        characterName="Мишарей"
        attackSignal="misharey_attack"
        healSignal="misharey_heal"
        attackDescription="Мелкие пули падают сверху, изначально мимо души. Урон 1."
        healDescription="Мимо поля пролетает пластырь. Одноразовая способность."
    />
);
